import React, {useEffect, useState} from "react";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn, RaikoLabel, RaikoLabelType,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {UsersListService} from "../../../serverService/usersListService/UsersListService";
import UserDashboardCard from "../../../component/userDashboardCard/UserDashboardCard";

export default function UserInstallationSummary() {


    const userService = new UsersListService();

    useEffect(() => {
        getUsersReport()
    }, []);

    const [todayUsers, setToday] = useState(0);
    const [currentWeek, setCurrentWeek] = useState(0);
    const [currentMonth, setCurrentMonth] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalOnlineUser, setTotalOnlineUser] = useState(0)

    function getUsersReport() {
        userService.getUserStatistical().then(
            response => {
                setToday(response.today)
                setCurrentWeek(response.currentWeek)
                setCurrentMonth(response.currentMonth)
                setTotalUsers(response.total)
                setTotalOnlineUser(response.totalOnlineUser)
            }
        ).catch(reason => {
            showServerErrorMessage(reason)
        })
    }

    return(
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoLabel text={"خلاصه نصب کاربران"} raikoLabelType={RaikoLabelType.TITLE}/>
                <div className={"userInformationContainer"}>
                    <UserDashboardCard colorKey={6} title={"کل"} number={totalUsers}/>
                    <UserDashboardCard colorKey={2} title={"یک ماه گذشته"} number={currentMonth}/>
                    <UserDashboardCard colorKey={1} title={"هفت روز گذشته"} number={currentWeek}/>
                    <UserDashboardCard colorKey={0} title={"24 ساعت گذشته"} number={todayUsers}/>
                    <UserDashboardCard colorKey={4} title={"کاربران آنلاین"} number={totalOnlineUser}/>
                    {/*<UserDashboardCard key={3} title={"سالانه"} number={currentMonth}/>*/}
                </div>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}